
import React from 'react';
import {FormHelper} from '../../../dist/src/index';
import {Button} from 'react-toolbox/lib/button';
import {Input} from 'react-toolbox/lib/input';


const store = {}
export const attributes = {"title":"Initial State"};
export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
  }
  render() {
    return (
      <div>
        {(store.example = <FormHelper
  saveButton='Save'
  buttonComponent={Button}
  buttonProps={{
    primary: true,
  }}
  inputComponent={Input}
  onSave={credentials => this.setState({credentials})}
  value={{email: 'user@example.com'}}
  fields={[
    {path: ['email'], icon: 'email', label: 'Email'},
  ]}
/>
, null)}<h4>Initial state</h4>
<p>Sometimes you need to provide the form with initial state, for example
when you edit an user.</p>
<h6>Code</h6>

    <div className="example">
      <div className="source">
        <pre><code className="language-jsx">
          <span className="token tag"><span className="token tag"><span className="token punctuation">&lt;</span>FormHelper</span>{"\n"}  <span className="token attr-name">saveButton</span><span className="token attr-value"><span className="token punctuation">=</span><span className="token punctuation">'</span>Save<span className="token punctuation">'</span></span>{"\n"}  <span className="token attr-name">buttonComponent</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>Button<span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">buttonProps</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token punctuation">{"{"}</span>{"\n"}    primary<span className="token punctuation">:</span> <span className="token boolean">true</span><span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">{"}"}</span><span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">inputComponent</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>Input<span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">onSave</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span>credentials <span className="token operator">=</span><span className="token operator">></span> <span className="token keyword">this</span><span className="token punctuation">.</span><span className="token function">setState</span><span className="token punctuation">(</span><span className="token punctuation">{"{"}</span>credentials<span className="token punctuation">{"}"}</span><span className="token punctuation">)</span><span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">value</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token punctuation">{"{"}</span>email<span className="token punctuation">:</span> <span className="token string">'user@example.com'</span><span className="token punctuation">{"}"}</span><span className="token punctuation">{"}"}</span></span>{"\n"}  <span className="token attr-name">fields</span><span className="token script language-javascript"><span className="token punctuation">=</span><span className="token punctuation">{"{"}</span><span className="token punctuation">[</span>{"\n"}    <span className="token punctuation">{"{"}</span>path<span className="token punctuation">:</span> <span className="token punctuation">[</span><span className="token string">'email'</span><span className="token punctuation">]</span><span className="token punctuation">,</span> icon<span className="token punctuation">:</span> <span className="token string">'email'</span><span className="token punctuation">,</span> label<span className="token punctuation">:</span> <span className="token string">'Email'</span><span className="token punctuation">{"}"}</span><span className="token punctuation">,</span>{"\n"}  <span className="token punctuation">]</span><span className="token punctuation">{"}"}</span></span>{"\n"}<span className="token punctuation">/></span></span>{"\n"}
        </code></pre>
      </div>
    </div><h6>Demo</h6>

    <div className="example">
      <div className="run"><div>
  {store.example}
</div>
</div>
    </div>
  <h6>State</h6>

    <div className="example">
      <div className="run"><div>
  <p>
    Credentials: {JSON.stringify(this.state.credentials)}
  </p>
</div>
</div>
    </div>
  
      </div>
    );
  }
};


/** WEBPACK FOOTER **
 ** ./docs/pages/Examples/04-initial-state.md
 **/